import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { Component, Input } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

/**
 * Asignación de los botones (en construcción) a las tres listas de la categoría:
 * Principales / Secundarios / Otros. Trabaja con `_tmpId` (los botones todavía no tienen `_id`
 * porque se crean al guardar). El orden dentro de cada lista = prioridad.
 *
 * Las tres arrays se reciben por referencia y se mutan in-place vía drag-drop (CDK), así el
 * provisionador ve los cambios sin eventos extra.
 */
@Component({
  selector: 'app-categoria-armado',
  templateUrl: './categoria-armado.component.html',
  styleUrls: ['./categoria-armado.component.scss'],
  standalone: false,
})
export class CategoriaArmadoComponent {
  /** FormArray de grupos de botón (cada uno con `_tmpId`, `nombre`, `funcion`...). */
  @Input() botones?: UntypedFormArray;
  @Input() idsPrincipales: string[] = [];
  @Input() idsSecundarios: string[] = [];
  @Input() idsOtros: string[] = [];

  public btnLabel(tmpId: string): string {
    const grupos = this.botones?.controls as UntypedFormGroup[] | undefined;
    const g = grupos?.find((c) => c.get('_tmpId')?.value === tmpId);
    if (!g) return tmpId;
    const nombre = g.get('nombre')?.value || 'sin nombre';
    const funcion = g.get('funcion')?.value;
    return funcion ? `${nombre} · ${funcion}` : nombre;
  }

  public drop(event: CdkDragDrop<string[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }
}
